import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { nestedRoutePath, routes } from '../../../constants/routes'

import AdminTemplateGroupView from './view'
import AdminTemplateGroupCreate from './create'
import AdminQuestionEdit from '../questions/edit'
import AdminTemplateGroupList from './list'

const AdminTemplateGroupIndex = () => {
    return (
        <>
            <div className="builder-view">
                <Routes>
                    <Route path={nestedRoutePath(routes.adminTemplateGroupIndex.path, routes.adminTemplateGroupView.path)} element={<AdminTemplateGroupView />} />
                    <Route path={nestedRoutePath(routes.adminTemplateGroupIndex.path, routes.adminTemplateGroupCreate.path)} element={<AdminTemplateGroupCreate />} />
                    <Route path={nestedRoutePath(routes.adminTemplateGroupIndex.path, routes.adminQuestionView.path)} element={<AdminQuestionEdit />} />
                    <Route index element={<AdminTemplateGroupList />} />
                </Routes>
            </div>
        </>
    )
}

export default AdminTemplateGroupIndex
